module.exports = __webpack_public_path__ + "img/usa-stomach-cancer-male.3a43fa6f.png";